import React from 'react';
import clsx from 'clsx';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Link,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import telegramLogo from 'assets/images/telegram.jpg'
import youtubeLogo from 'assets/images/youtube.png'
import facebookLogo from 'assets/images/facebook.png'
import instagramLogo from 'assets/images/instagram.png'

export default function SocialMediaSection() {
  const classes = useStyles();
  return (
    <Grid container spacing={3}>
      <Grid item xs={6} sm={3}>
        <a className={classes.socialLink} href="https://t.me/zwagilfoundation">
          <Card className={clsx(classes.card, 'Social Media')}>
            <CardContent className={classes.cardContent}>
              <div className={classes.sLogo}>
                <img src={telegramLogo} width="53" height="53" />
              </div>
              <div className={classes.follow}>Follow us on Telegram</div>
            </CardContent>
          </Card>
        </a>
      </Grid>
      <Grid item xs={6} sm={3}>
        <a className={classes.socialLink} href="https://www.youtube.com/channel/UCz-orA59ikvfWiVHZ94aPZA">
          <Card className={clsx(classes.card, 'Social Media')}>
            <CardContent className={classes.cardContent}>
              <div className={classes.sLogo}>
                <img src={youtubeLogo} width="61" height="44" />
              </div>
              <div className={classes.follow}>Follow us on Youtube</div>
            </CardContent>
          </Card>
        </a>
      </Grid>
      <Grid item xs={6} sm={3}>
        <a className={classes.socialLink} href="https://www.facebook.com/zwagilfoundation/">
          <Card className={clsx(classes.card, 'Social Media')}>
            <CardContent className={classes.cardContent}>
              <div className={classes.sLogo}>
                <img src={facebookLogo} width="80" height="54" />
              </div>
              <div className={classes.follow}>Follow us on Facebook</div>
            </CardContent>
          </Card>
        </a>
      </Grid>
      <Grid item xs={6} sm={3}>
        <a className={classes.socialLink} href="https://www.instagram.com/zwagilfoundation/">
          <Card className={clsx(classes.card, 'Social Media')}>
            <CardContent className={classes.cardContent}>
              <div className={classes.sLogo}>
                <img src={instagramLogo} width="76" height="71" />
              </div>
              <div className={classes.follow}>Follow us on Instagram</div>
            </CardContent>
          </Card>
        </a>
      </Grid>
    </Grid>
  );
}


const useStyles = makeStyles((theme) => ({
  card: {
    boxShadow: "0px 2px 10px #E5E9F2",
    borderRadius: 5,
    border: '1px solid #E6EAEE'
  },
  cardHeader: {
    padding: theme.spacing(2, 3, 0, 3),
  },
  title: {
    fontSize: 16,
    fontWeight: 500,
  },
  cardContent: {
    paddingTop: 11,
    height: 120,
    textAlign: 'center'
  },
  follow: {
    fontWeight: 600,
    fontSize: 16
  },
  sLogo: {
    height: 80,
    paddingTop: 10
  },
  socialLink: {
    textDecoration: 'none',
  },
  settingIcon: {
    width: 20,
    height: 20
  }
}));

